<script setup lang="ts">
import type { QuoteData } from '~/utils/crystallize/pieces'

defineProps<{ data: QuoteData }>()
</script>

<template>
  <UBlockquote
    variant="neutral"
    :author="
      data.author?.name
        ? {
          name: data.author.name,
          role: data.author.title,
        } : undefined
    "
  >
    <template v-for="(block, i) in data.text" :key="i">
      <CrystallizeRichText :block="block" />
    </template>
  </UBlockquote>
</template>
